import {
  VisitorUser,
  UserStatus,
  VisitorStatus,
  VisitorsSummary,
  SecurityClearance,
} from '../../apis/users/users.api.interfaces';

export const mockVisitorUsers: VisitorUser[] = [
  {
    id: 'visitor-1',
    firstName: 'Amit',
    lastName: 'Singh',
    email: 'amit.singh@techcorp.com',
    phone: '+91-9876543250',
    status: UserStatus.ACTIVE,
    createdDate: '2024-01-15',
    lastActive: '2024-01-15',
    visitDate: '2024-01-20',
    visitTime: '10:00 AM',
    visitDuration: 120,
    visitPurpose: 'Technology Workshop for Students',
    hostPerson: 'Mr. Ravi Kumar',
    hostDepartment: 'Computer Science',
    visitStatus: VisitorStatus.SCHEDULED,
    idDocumentType: 'Driving License',
    idDocumentNumber: 'DL1420110012345',
    securityClearance: SecurityClearance.STANDARD,
    vehicleDetails: {
      vehicleType: 'Honda',
      vehicleModel: 'City',
      vehicleNumber: 'KA01AB1234',
    },
    visitHistory: [
      {
        id: 'visit-1',
        date: '2023-12-15',
        purpose: 'AI Workshop',
        duration: 180,
        host: 'Mr. Ravi Kumar',
        status: VisitorStatus.COMPLETED,
      },
    ],
    address: {
      street: '100 Tech Park',
      city: 'Bangalore',
      state: 'Karnataka',
      zipCode: '560066',
      country: 'India',
    },
    notes:
      'Regular technology workshop facilitator. Excellent feedback from students.',
  },
  {
    id: 'visitor-2',
    firstName: 'Dr. Meera',
    lastName: 'Iyer',
    email: 'meera.iyer@healthclinic.com',
    phone: '+91-9876543260',
    status: UserStatus.ACTIVE,
    createdDate: '2024-01-16',
    lastActive: '2024-01-16',
    visitDate: '2024-01-17',
    visitTime: '9:00 AM',
    visitDuration: 240,
    visitPurpose: 'Annual Health Checkup for Students',
    hostPerson: 'Mrs. Kavita Singh',
    hostDepartment: 'Health & Safety',
    visitStatus: VisitorStatus.COMPLETED,
    checkInTime: '8:55 AM',
    checkOutTime: '1:10 PM',
    idDocumentType: 'Medical License',
    idDocumentNumber: 'MED12345KA',
    visitorBadgeNumber: 'VB001',
    securityClearance: SecurityClearance.HIGH,
    visitHistory: [
      {
        id: 'visit-2',
        date: '2023-01-15',
        purpose: 'Annual Health Checkup',
        duration: 300,
        host: 'Mrs. Kavita Singh',
        status: VisitorStatus.COMPLETED,
      },
      {
        id: 'visit-3',
        date: '2023-06-10',
        purpose: 'Health Awareness Program',
        duration: 120,
        host: 'Mrs. Kavita Singh',
        status: VisitorStatus.COMPLETED,
      },
    ],
    address: {
      street: '50 Medical Complex',
      city: 'Bangalore',
      state: 'Karnataka',
      zipCode: '560017',
      country: 'India',
    },
    notes:
      'Certified school health consultant. Annual contract for health services.',
  },
  {
    id: 'visitor-3',
    firstName: 'Rakesh',
    lastName: 'Gupta',
    email: 'rakesh.gupta@parentemail.com',
    phone: '+91-9876543270',
    status: UserStatus.ACTIVE,
    createdDate: '2024-01-18',
    lastActive: '2024-01-18',
    visitDate: '2024-01-18',
    visitTime: '2:00 PM',
    visitDuration: 60,
    visitPurpose: 'Student Admission Inquiry',
    hostPerson: 'Mrs. Sunita Agarwal',
    hostDepartment: 'Admissions',
    visitStatus: VisitorStatus.CHECKED_OUT,
    checkInTime: '1:55 PM',
    checkOutTime: '3:15 PM',
    idDocumentType: 'Aadhar Card',
    idDocumentNumber: 'XXXX-XXXX-1234',
    visitorBadgeNumber: 'VB002',
    securityClearance: SecurityClearance.BASIC,
    vehicleDetails: {
      vehicleType: 'Maruti',
      vehicleModel: 'Swift',
      vehicleNumber: 'KA02CD5678',
      parkingSpot: 'P-15',
    },
    visitHistory: [],
    address: {
      street: '200 Residential Area',
      city: 'Bangalore',
      state: 'Karnataka',
      zipCode: '560076',
      country: 'India',
    },
    notes: 'Prospective parent inquiring about admission process for Grade 6.',
  },
  {
    id: 'visitor-4',
    firstName: 'Sarah',
    lastName: 'Johnson',
    email: 'sarah.johnson@supplies.com',
    phone: '+91-9876543280',
    status: UserStatus.ACTIVE,
    createdDate: '2024-01-19',
    lastActive: '2024-01-19',
    visitDate: '2024-01-22',
    visitTime: '11:00 AM',
    visitPurpose: 'Laboratory Equipment Demonstration',
    hostPerson: 'Mr. Rajesh Kumar',
    hostDepartment: 'Science Laboratory',
    visitStatus: VisitorStatus.SCHEDULED,
    idDocumentType: 'Passport',
    idDocumentNumber: 'P1234567',
    securityClearance: SecurityClearance.STANDARD,
    visitHistory: [
      {
        id: 'visit-4',
        date: '2023-09-20',
        purpose: 'Equipment Installation',
        duration: 480,
        host: 'Mr. Rajesh Kumar',
        status: VisitorStatus.COMPLETED,
      },
    ],
    address: {
      street: '75 Industrial Area',
      city: 'Bangalore',
      state: 'Karnataka',
      zipCode: '560058',
      country: 'India',
    },
    notes:
      'Authorized vendor for laboratory equipment. Regular maintenance visits.',
  },
];

export const mockVisitorUsersSummary: VisitorsSummary = {
  totalVisitors: 4,
  checkedInVisitors: 1,
  checkedOutVisitors: 1,
  scheduledVisitors: 2,
};
